import {Directive, Input, TemplateRef} from '@angular/core';
import {FormControl} from "@angular/forms";
import {JdDyFormOptionItem} from "./dy-form.interface";


export class CustomControlContext {
  constructor(public $implicit: FormControl, public config: JdDyFormOptionItem) {
  }
}

@Directive({
  selector: '[jdCustomControlRef]'
})
export class CustomControlDirective {

  @Input() jdCustomControlRefName: string;

  constructor(public templateRef: TemplateRef<CustomControlContext>) {
  }

}
